import type { ElementType } from 'react';
import React from 'react';

import Chip from '@mui/material/Chip';

import { StatusTaskCheckEnum } from '@/types/enums/status-task-check.enum';
import { t } from '@/utils/lang';

interface StatusChipProps {
    status: StatusTaskCheckEnum;
    size?: 'small' | 'medium';
    component?: ElementType;
    showChip?: boolean;
}

const ChipTaskCheckStatus: React.FC<StatusChipProps> = ({
    status,
    size = 'medium',
    component: Component = Chip,
    showChip = true,
}) => {
    let label: string;
    let color: 'primary' | 'info' | 'warning' | 'success' | 'error' | 'default';

    switch (status?.toLowerCase()) {
        case StatusTaskCheckEnum.CREATED.toLowerCase():
            label = 'Chưa thực hiện';
            color = 'primary';
            break;
        case StatusTaskCheckEnum.DONE.toLowerCase():
            label = 'Hoàn thành';
            color = 'success';
            break;
        case StatusTaskCheckEnum.CANCEL.toLowerCase():
            label = 'Đã hủy';
            color = 'error';
            break;
        case StatusTaskCheckEnum.NOT_YET.toLowerCase():
        case 'notyet':
            label = 'Không hoàn thành';
            color = 'warning';
            break;
        case StatusTaskCheckEnum.DRAFT.toLowerCase():
        case 'draft':
            label = 'Lưu tạm';
            color = 'info';
            break;
        case StatusTaskCheckEnum.DECLINED.toLowerCase():
            label = 'Từ chối';
            color = 'default';
            break;
        default:
            label = 'Không xác định';
            color = 'default';
            break;
    }

    if (showChip) {
        const isCreated =
            status?.toLowerCase() === StatusTaskCheckEnum.CREATED.toLowerCase();

        return (
            <Component
                variant='tonal'
                label={t(label, 'TaskStatus')}
                color={color}
                size={size}
                sx={{
                    fontSize: 12,
                    ...(isCreated && {
                        backgroundColor: 'rgba(235, 241, 250, 0.5)',
                    }),
                }}
            />
        );
    }

    return {
        label: t(label, 'TaskStatus'),
        color,
    };
};

export default ChipTaskCheckStatus;
